<template>
  <div class="px-4 py-3 text-center normal text-color-2">
    <div class="mb-1">
      <div class="ml-2 bold">فرستنده:</div>
      <div class="">
        {{ details_data.user_name }}
      </div>
    </div>
    <div v-if="details_data.receiver_name" class="mb-1">
      <div class="ml-2 bold">گیرنده:</div>
      <div class="d-inline-block">
        {{ details_data.receiver_name }}
      </div>
    </div>
    <div class="ml-2 bold mb-1">محصولات:</div>
    <div
      v-for="(item, index) in details_data.product"
      :key="index"
      class="mb-1 p-1 flower text-center"
    >
      <div class="image-wrapper">
        <img :src="item.image" />
      </div>
      <div class="">
        {{ item.name }}
      </div>
      <div class="">{{ item.number }} عدد</div>
      <div>{{ SeparatorNumber(item.price) }} تومان</div>
    </div>
    <div class="mb-1">
      <div class="ml-2 bold">توضیح :</div>
      <div class="d-inline-block my-alarm _2">
        {{ details_data.desc }}
      </div>
    </div>

    <div v-if="details_data.receiver_mobile" class="mb-1">
      <div class="ml-2 bold">تاریخ ارسال:</div>
      <div class="d-inline-block">
        {{ details_data.delivery_day }}
      </div>
    </div>
    <div class="mb-1">
      <div class="ml-2 bold">بازه زمانی سفارش:</div>
      <div class="d-inline-block">
        <div v-if="details_data.delivery_time_from">
          از {{ details_data.delivery_time_from }} تا
          {{ details_data.delivery_time_to }}
        </div>
      </div>
    </div>
    <div class="mb-1">
      <div class="ml-2 bold">موبایل فرستنده:</div>
      <div class="d-inline-block">
        {{ details_data.user_phone }}
      </div>
    </div>

    <div v-if="details_data.receiver_mobile" class="mb-1">
      <div class="ml-2 bold">موبایل گیرنده:</div>
      <div class="d-inline-block">
        {{ details_data.receiver_mobile }}
      </div>
    </div>
    <div class="mb-1">
       <a target="_blank"
          v-if="details_data.lat"
          :href="
            'https://www.google.com/maps/search/?api=1&query=' +
            details_data.lat +
            ',' +
            details_data.long
          "
          >‍‍‍‍<button class="bold normal">لوکیشن</button></a
        >
    </div>

    <div class="mb-1">
      <div class="ml-2 bold">آدرس:</div>
      <div class="d-inline-block">
        {{ details_data.user_address }}
      </div>
    </div>
  </div>
</template>

<script>
import jalalim from "jalali-moment";
import Service from "../../../../utils/seller-service";
import SeparatorNumber from "../../../../utils/MyTools";
export default {
  name: "details_order",
  props: ["order"],
  data: () => ({
    dialog: false,
    image_choose: false,
    image_uploaded: false,
    product_image: {},
    snackbar: false,
    details_data: {},
  }),
  methods: {
    submit_image() {
      this.authService.receive(
        "seller/order/" + this.order.id,
        {},
        (s, d) => {
          this.details_data = d.data;
          this.details_data.delivery_day = jalalim(
            this.details_data.delivery_day
          )
            .locale("fa")
            .format("YYYY/MM/DD");
        },
        (s, e) => {}
      );
    },
    SeparatorNumber(number) {
      return SeparatorNumber(number);
    },
  },
  computed: {
    theDate: function () {
      return jalalim(this.theOrder.pay_time).locale("fa").format("YY/MM/DD");
    },
    authService: function () {
      return Service(true);
    },
  },
  mounted() {
    this.submit_image();
  },
};
</script>

<style lang="scss" scoped>
.item-picture {
  width: 100%;
}
.flower {
  background: #fee7f9;
  border-radius: 15px;
  color: #6a0048;
}
.image-wrapper {
  padding: 10px;
  img {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    display: block;
    border-radius: 10px;
  }
}
</style>